export const isNullOrUndefined = (value) => {
  return value === null || value === undefined;
};

export const isNullOrEmpty = (value) => {
  return isNullOrUndefined(value) || value.length === 0;
};


export const isNumberValid = (value) => {
  return !(isNullOrUndefined(value) || Number.isNaN(value));
};

export const valorString = (value) => {
  return isNullOrUndefined(value) ? '' : value;
};


export const extractPartOfStringByDelimiter = (value: string, delimiter: string, position: number) => {
  return value.split(delimiter)[position];
};

export const extractStringByDelimiter = (value: string, delimiter: string) => {
  return value.split(delimiter);
};

export const convertArrayToString = (array: any[]) => {
  let val = '';
  array.forEach((value, index) => {
    val = val.concat(value);
    val = index !== (array.length - 1) ? val.concat(',') : val;
  });
  return val;
};

export const toQuery = (params, delimiter = '&') => {
	const keys = Object.keys(params);
	return keys.reduce((str, key, index) => {
		let query = `${str}${key}=${params[key]}`;

		if (index < (keys.length - 1)) {
			query += delimiter;
		}
		return query;
	}, '');
};


export const verificarParametrosDispositvoAptoConfig = (parametro: string) => {
	const params: string[] = ['MOSTRAR_CONTATO_VENDEDOR', 'MOSTRAR_CONTATO_SUPERVISOR', 'MOSTRAR_CONTATO_CLIENTE',
		'RAIO_DE_TOLERANCIA_NO_CHECKIN_CLIENTE', 'AUTORIZACAO_ALTERACAO_COORDENADAS', 'RAIO_FURO_CERCA',
		'OBRIGAR_FOTO_CANHOTO_DEVOLUCAO_TOTAL', 'FOTO_CHECKIN_OBRIGATORIA', 'OBRIGAR_FOTO_DEVOLUCAO', 'ALERTA_TEMPO_MAXIMO_ENTREGA', 'EXIBIR_NOTIFICACAO_RETORNO_VIAGEM',
		'ALERTA_TEMPO_MAXIMO_ESPERA', 'ALERTA_TEMPO_MAXIMO_LOCOMOCAO_ENTRE_CLIENTES', 'INTERVALO_GERACAO_ALERTAS',
		'ALERTA_FURO_SEQUENCIA_ENTREGA', 'ALERTA_EM_CASO_DE_DEVOLUCAO', 'ALERTA_EM_CASO_DE_FILA_ESPERA', 'ALERTA_BATERIA_PROX_FIM',
		'ALERTA_FURO_CERCA', 'ALERTA_EXCESSO_VELOCIDADE', 'VALOR_PADRAO_DE_VELOCIDADE_LIMITE', 'PLACA_VEICULO_OBRIGATORIA', 'UTILIZA_HODOMETRO'
	];
	return parametro && params.includes(parametro);
};

export const ifExistListAndIsEmptyListNull = (list: any[]) => {
	return list && list.length > 0 ? list : null;
};

export const sortByPropAlfabetica = (prop: string, array: any[]) => {
	try {
		return !isNullOrUndefined(array) && array.length ? array.sort((a, b) => a[prop].localeCompare(b[prop])) : array;
	} catch (err) {
		console.error(err);
		return array;
	}
};

export const sleep = (ms: number) => {
	return new Promise(resolve => setTimeout(resolve, ms));
};

export const convertZeroString = (valor: any) => {
	return isNullOrUndefined(valor) ? '0' : valor;
};
